import { render, staticRenderFns } from "./ListaIngresoCartaPorte.vue?vue&type=template&id=048bfe16&"
import script from "./ListaIngresoCartaPorte.vue?vue&type=script&lang=js&"
export * from "./ListaIngresoCartaPorte.vue?vue&type=script&lang=js&"
import style0 from "./ListaIngresoCartaPorte.vue?vue&type=style&index=0&id=048bfe16&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports